import React from "react";
import PropTypes from "prop-types";

export function LayoutWrapper1xbet({ children, className = "" }) {
  return (
    <div
      className={`relative size-full flex flex-col justify-around items-center min-h-[450px] pt-4 pb-8 px-4 sm:px-14 bg-white ${className}`}
    >
      {children}
    </div>
  );
}

LayoutWrapper1xbet.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
